import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import {
  Form,
  UsersAutocomplete,
  PlansAutocomplete
} from "@shared/components";

export function SubscriptionForm({ multiplePlans = false }: { multiplePlans?: boolean }) {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <UsersAutocomplete
          name="user"
          label={translate("subscription_admin.fields.user")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="cpf"
          label={translate("v1/user_admin.fields.cpf")}
          mask="cpf"
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <PlansAutocomplete
          multiple={multiplePlans}
          name="plan"
          label={translate(
            multiplePlans
              ? "subscription_admin.fields.plans"
              : "subscription_admin.fields.plan"
          )}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.DatePicker
          name="start_date"
          label={translate("subscription_admin.fields.start_date")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.DatePicker
          name="valid_until"
          label={translate("subscription_admin.fields.valid_until")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="active"
          label={translate("subscription_admin.fields.active")}
        />
      </Grid>
    </Grid>
  );
}
